import { Switch } from "@chakra-ui/react";
import React from "react";

const DSwitch = ({ isChecked, onChange, id, label, ...rest }) => {
    return (
        <div>
            {label && (
                <label htmlFor={id} className="me-1">
                    {label}
                </label>
            )}
            <Switch
                id={id}
                {...rest}
                isChecked={isChecked}
                onChange={onChange}
            />
        </div>
    );
};

export default DSwitch;
